<template>
  <div class="core">

   <child />
  </div>


</template>

<script>

export default {
  name: 'MainLayout',

  methods: {
      toggleNav: function(){
        this.navOpen = ( this.navOpen ? false : true );
      }
  },

  data() {
    return {
      navOpen: false,
    }
  },

  components: {
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/default.vue